import * as React from 'react';
import PropTypes from 'prop-types';
import {Link} from "@fitplan/lib/components/Link";

import './trainer-card.scss';
import { getAthleteName } from '../../utils/helpers';
import { IAthlete } from '../../types/backend';
import { css } from '@emotion/core';

export const TrainerCard: React.FunctionComponent<IAthlete> = props => {
  const { url, athleteImage } = props;
  return (
    <Link
      to={`/trainers/${url}`}
      css={css`text-decoration: none;`}
      className="trainers__card"
    >
      <div className="trainers__card-image">
          <img src={athleteImage} className="trainers__card-image-block" />
        <div className="trainers__card-overlay" />
        <div className="trainers__card-name">
          {getAthleteName(props)}
          <div className="trainers__card-desc">
            {props.athleteShortDescription}
          </div>
        </div>
      </div>
    </Link>
  );
};

export const ListCard: React.FunctionComponent<IAthlete> = props => {
  const {
    url,
    athleteImage,
    athleteShortDescription,
  } = props;
  return (
    <Link
      to={`/trainers/${url}`}
      css={css`text-decoration: none;`}
      className="list__card"
    >
      <div className="list__card-image">
          <img src={athleteImage} style={{ width: '100%' }} />
      </div>
      <div className="list__card-description-container">
        <div className="list__card-description">
          <div className="list__card-name">{getAthleteName(props)}</div>
          <div className="list__card-athlete-description">
            {athleteShortDescription}
          </div>
        </div>
      </div>
    </Link>
  );
};

TrainerCard.propTypes = {
  slug: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
};
